import {GROUP_HEADER_HEIGHT} from '../common/group/styled-group-header'
import {OMNIBAR_HEIGHT} from '../omnibar/omnibar'
import {ROW_DRAG_HANDLE_WIDTH} from '../react_table/row-dragger'

export const ROADMAP_DRAG_HANDLE_WIDTH = 16
export const ROADMAP_ROW_HEIGHT = 40
export const ROADMAP_PILL_HEIGHT = 28

/** The default width to use for the title column in the Roadmap layout, overriding the default width for the column */
export const ROADMAP_TITLE_COLUMN_DEFAULT_WIDTH = 420
export const ROADMAP_TITLE_COLUMN_MAX_WIDTH = 1000
export const ROADMAP_TITLE_COLUMN_MIN_WIDTH = 75
export const ROADMAP_NUMBER_COLUMN_WIDTH = ROW_DRAG_HANDLE_WIDTH
export const ROADMAP_DATE_COLUMN_WIDTH = 120
export const ROADMAP_ITEM_GRAB_HANDLE_WIDTH = 21
export const ROADMAP_ITEM_GRAB_HANDLE_HEIGHT = 21
export const PILL_PADDING = 8
export const PILL_STICKY_MARGIN = 8
export const PILL_BORDER_RADIUS = 5
export const ADD_BUTTON_ICON_WIDTH = 22
export const ADD_BUTTON_MARGIN = 8
export const ADD_BUTTON_WIDTH = ADD_BUTTON_MARGIN + ADD_BUTTON_ICON_WIDTH

export const roadmapCssVariables = {
  '--roadmap-group-header-height': `${GROUP_HEADER_HEIGHT}px`,
  '--roadmap-row-height': `${ROADMAP_ROW_HEIGHT}px`,
  '--roadmap-pill-height': `${ROADMAP_PILL_HEIGHT}px`,
  '--roadmap-title-column-default-width': `${ROADMAP_TITLE_COLUMN_DEFAULT_WIDTH}px`,
  '--roadmap-title-column-max-width': `${ROADMAP_TITLE_COLUMN_MAX_WIDTH}px`,
  '--roadmap-title-column-min-width': `${ROADMAP_TITLE_COLUMN_MIN_WIDTH}px`,
  '--roadmap-number-column-width': `${ROADMAP_NUMBER_COLUMN_WIDTH}px`,
  '--roadmap-date-column-width': `${ROADMAP_DATE_COLUMN_WIDTH}px`,
  '--roadmap-item-grab-handle-width': `${ROADMAP_ITEM_GRAB_HANDLE_WIDTH}px`,
  '--roadmap-item-grab-handle-height': `${ROADMAP_ITEM_GRAB_HANDLE_HEIGHT}px`,
  '--roadmap-pill-padding': `${PILL_PADDING}px`,
  '--roadmap-pill-sticky-margin': `${PILL_STICKY_MARGIN}px`,
  '--roadmap-pill-border-radius': `${PILL_BORDER_RADIUS}px`,
  '--roadmap-drag-handle-width': `${ROADMAP_DRAG_HANDLE_WIDTH}px`,
  '--add-button-icon-width': `${ADD_BUTTON_ICON_WIDTH}px`,
  '--add-button-margin': `${ADD_BUTTON_MARGIN}px`,
  '--add-button-width': `${ADD_BUTTON_WIDTH}px`,
  '--omnibar-height': `${OMNIBAR_HEIGHT}px`,
}
